import { Monitor } from "react-feather";
import { useTranslation } from "react-i18next";
import { Modal } from "../modal/Modal.js";
import { Button } from "../button/Button.js";
import { Typography } from "../typography/Typography.js";
import styles from "./MobileWarningDialog.module.css";

interface MobileWarningDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileWarningDialog({ isOpen, onClose }: MobileWarningDialogProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal
      handleClose={onClose}
      closeButton={false}
      outsideClose={false}
      modalStyles={{ maxWidth: "400px" }}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <Monitor size={48} className={styles.icon} />
        </div>

        <div className={styles.content}>
          <div className={styles.title}>
            <Typography sizes={["h5", "bold"]}>
              {t("mobileWarning.title")}
            </Typography>
          </div>

          <div className={styles.description}>
            <Typography sizes={["body"]}>
              {t("mobileWarning.description")}
            </Typography>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            theme="cta"
            onClick={onClose}
          >
            {t("mobileWarning.button")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
